// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"tabPane_wrapper__38rfi","selected":"tabPane_selected__3c2I2"};